import { IGlobalPrice } from '@@sapporo/price/interface/IGlobalPrice';

import { numberFormat } from '..';

export interface IPriceInfo {
  amount: string;
  unit: string;
}
/**
 * API 가격정보를 받아, 가격의 형식을 맞춘 후 화폐 단위와 함께 반환한다.
 */
export const formatPriceInfo = (price?: IGlobalPrice | null): IPriceInfo | undefined => {
  if (!price?.amount) {
    return;
  }

  return {
    amount: numberFormat(price.amount),
    unit: price.to.read || '원',
  };
};
